/* anamkara-landing.js — F-series. Loaded only by layout/password.liquid.
   1) small countdown  2) signup sheet (email/SMS)  3) CROSSWORD (solve = enter early)  4) owner password field.
   ---- EDIT THE CROSSWORD HERE ---------------------------------------------------------------------
   Grid is rows x cols. Each entry: n (number), dir (A/D), r, c (start cell), word, clue.
   The across entry ANAMKARA is the key: the store password must literally be ANAMKARA (PASSWORD below).
   Cells that no entry covers are drawn as black blocks. Entries must cross on matching letters. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var stage = $('#ld-stage');

  var PASSWORD = 'ANAMKARA';
  var ROWS = 7, COLS = 8;
  var ENTRIES = [
    { n: 1, dir: 'D', r: 0, c: 4, word: 'TOKYO',    clue: 'Neon-lit capital behind this page' },
    { n: 2, dir: 'D', r: 1, c: 0, word: 'RACING',   clue: 'Soul Friend ___' },
    { n: 3, dir: 'D', r: 1, c: 2, word: 'LACE',     clue: 'Sheer white fabric' },
    { n: 4, dir: 'D', r: 1, c: 6, word: 'DROP',     clue: '001 is the first one' },
    { n: 5, dir: 'A', r: 2, c: 0, word: 'ANAMKARA', clue: 'The name on the door' },
    { n: 6, dir: 'A', r: 6, c: 0, word: 'GLITCH',   clue: 'Signal fault, sometimes on purpose' }
  ];

  /* ---------- countdown (compact) ---------- */
  var clock = $('#ak-countdown');
  if (clock) {
    var target = new Date(clock.getAttribute('data-target')).getTime();
    var els = { d: $('#ld-d'), h: $('#ld-h'), m: $('#ld-m'), s: $('#ld-s') };
    var dateEl = $('#ld-date');
    var liveEl = $('#ld-live');
    var timer;
    if (isNaN(target)) { clock.hidden = true; }
    else {
      if (dateEl) {
        try {
          dateEl.textContent = new Intl.DateTimeFormat(undefined, {
            month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short'
          }).format(new Date(target));
        } catch (e) { dateEl.textContent = ''; }
      }
      var pad = function (n) { return String(n).padStart(2, '0'); };
      var tick = function () {
        var diff = Math.max(0, target - Date.now());
        var d = Math.floor(diff / 86400000); diff -= d * 86400000;
        var h = Math.floor(diff / 3600000); diff -= h * 3600000;
        var m = Math.floor(diff / 60000); diff -= m * 60000;
        var s = Math.floor(diff / 1000);
        els.d.textContent = pad(d); els.h.textContent = pad(h); els.m.textContent = pad(m); els.s.textContent = pad(s);
        if (target - Date.now() <= 0) {
          if (stage) stage.classList.add('is-live');
          if (liveEl) liveEl.hidden = false;
          clearInterval(timer);
        }
      };
      tick();
      timer = setInterval(tick, 1000);
    }
  }

  /* ---------- signup sheet ---------- */
  var sheet = $('#ld-sheet');
  var tabs = $('#ld-tabs');
  var msg = $('#ld-msg');
  var mode = 'notify';
  var lastFocus = null;

  function setTab(name) {
    if (!tabs) return;
    tabs.setAttribute('data-tab', name);
    $$('.ld-tab', tabs).forEach(function (t) {
      var on = t.getAttribute('data-tab') === name;
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    $$('.ld-panel', sheet).forEach(function (p) {
      p.classList.toggle('is-on', p.getAttribute('data-panel') === name);
    });
    if (msg) { msg.textContent = ''; msg.className = 'ld-msg'; }
  }

  function setMode(m) {
    mode = m;
    var title = $('#ld-sheet-title');
    var sub = $('#ld-sheet-sub');
    if (title) title.textContent = m === 'preorder' ? 'Pre-order list' : 'Drop alerts';
    if (sub) sub.textContent = m === 'preorder' ? 'Reserve your place before the doors open.' : 'Be first when the doors open.';
    $$('input[data-base-tags]', sheet).forEach(function (inp) {
      var base = inp.getAttribute('data-base-tags');
      inp.value = m === 'preorder' ? base + ',pre-order' : base;
    });
  }

  function openSheet(m, tab) {
    if (!sheet) return;
    lastFocus = document.activeElement;
    setMode(m || 'notify');
    setTab(tab || 'email');
    sheet.classList.add('open');
    sheet.setAttribute('aria-hidden', 'false');
    setTimeout(function () {
      var f = $('.ld-panel.is-on input:not([type=hidden])', sheet);
      if (f) f.focus({ preventScroll: true });
    }, 350);
  }
  function closeSheet() {
    if (!sheet) return;
    sheet.classList.remove('open');
    sheet.setAttribute('aria-hidden', 'true');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  $$('[data-open-sheet]').forEach(function (b) {
    b.addEventListener('click', function () { openSheet(b.getAttribute('data-open-sheet')); });
  });
  $$('[data-close-sheet]').forEach(function (b) { b.addEventListener('click', closeSheet); });
  if (tabs) $$('.ld-tab', tabs).forEach(function (t) {
    t.addEventListener('click', function () { setTab(t.getAttribute('data-tab')); });
  });

  /* SMS form: Shopify's customer form has no phone-consent field, so the phone rides along as a tag. */
  var smsForm = $('#ld-form-sms');
  if (smsForm) {
    smsForm.addEventListener('submit', function (e) {
      var phone = $('#ld-phone');
      var digits = phone ? phone.value.replace(/[^\d+]/g, '') : '';
      var count = digits.replace(/\D/g, '').length;
      if (count < 10 || count > 15) {
        e.preventDefault();
        if (msg) { msg.textContent = 'Enter a valid phone number.'; msg.className = 'ld-msg err'; }
        if (phone) phone.focus();
        return;
      }
      var tagInput = $('input[name="contact[tags]"]', smsForm);
      if (tagInput) tagInput.value = tagInput.value + ',phone:' + digits;
    });
  }

  /* result of a posted form (Shopify reloads the page) */
  var res = window.AK_SIGNUP || {};
  if (sheet && (res.done || res.error)) {
    openSheet('notify', res.done ? res.done : res.error);
    if (msg) {
      if (res.done) { msg.textContent = "You're on the list."; msg.className = 'ld-msg ok'; }
      else { msg.textContent = 'Something went wrong. Check the details and try again.'; msg.className = 'ld-msg err'; }
    }
  }


  /* ---------- crossword ---------- */
  var gridEl = $('#cw-grid');
  if (gridEl) {
    var inputEl = $('#cw-input');
    var nowEl = $('#cw-now');
    var statusEl = $('#cw-status');
    var cellMap = {};          // "r,c" -> { r, c, ans, val, el, A: entry|null, D: entry|null, num }
    var order = [];            // entries in number order (across then down for same n)

    ENTRIES.forEach(function (e) {
      e.cells = [];
      for (var i = 0; i < e.word.length; i++) {
        var r = e.r + (e.dir === 'D' ? i : 0);
        var c = e.c + (e.dir === 'A' ? i : 0);
        var k = r + ',' + c;
        var cell = cellMap[k] || (cellMap[k] = { r: r, c: c, ans: e.word[i], val: '', A: null, D: null, num: 0 });
        cell[e.dir === 'A' ? 'A' : 'D'] = e;
        if (i === 0) cell.num = e.n;
        e.cells.push(cell);
      }
      order.push(e);
    });

    gridEl.style.setProperty('--cols', COLS);
    gridEl.style.setProperty('--rows', ROWS);
    for (var r = 0; r < ROWS; r++) {
      for (var c = 0; c < COLS; c++) {
        var cell = cellMap[r + ',' + c];
        var el = document.createElement('div');
        if (!cell) { el.className = 'cw-cell cw-block'; el.setAttribute('aria-hidden', 'true'); gridEl.appendChild(el); continue; }
        el.className = 'cw-cell';
        el.setAttribute('role', 'gridcell');
        el.dataset.r = r; el.dataset.c = c;
        if (cell.A && cell.A.word === PASSWORD) el.classList.add('is-key');
        if (cell.num) { var nn = document.createElement('i'); nn.textContent = cell.num; el.appendChild(nn); }
        var ch = document.createElement('span');
        el.appendChild(ch);
        cell.el = el; cell.ch = ch;
        gridEl.appendChild(el);
      }
    }

    /* clue lists */
    var listA = $('#cw-across'), listD = $('#cw-down');
    ENTRIES.forEach(function (e) {
      var li = document.createElement('li');
      li.innerHTML = '<b>' + e.n + '</b><span></span><em>' + e.word.length + '</em>';
      li.querySelector('span').textContent = e.clue;
      li.addEventListener('click', function () { selectEntry(e); focusInput(); });
      e.li = li;
      (e.dir === 'A' ? listA : listD).appendChild(li);
    });

    var cur = null;            // active cell
    var dir = 'A';
    var done = false;

    function entryOf(cell, d) { return cell[d === 'A' ? 'A' : 'D']; }
    function activeEntry() { return cur ? (entryOf(cur, dir) || entryOf(cur, dir === 'A' ? 'D' : 'A')) : null; }

    function paint() {
      var ent = activeEntry();
      Object.keys(cellMap).forEach(function (k) {
        var cl = cellMap[k];
        cl.el.classList.toggle('in-word', !!(ent && ent.cells.indexOf(cl) > -1));
        cl.el.classList.toggle('is-cur', cl === cur);
      });
      ENTRIES.forEach(function (e) { e.li.classList.toggle('is-on', e === ent); });
      if (ent && nowEl) nowEl.innerHTML = '<b>' + ent.n + ' ' + (ent.dir === 'A' ? 'Across' : 'Down') + '</b> ' + escapeHtml(ent.clue) + ' <em>(' + ent.word.length + ')</em>';
    }
    function escapeHtml(s) { return s.replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }

    function selectCell(cell, toggle) {
      if (!cell) return;
      if (cur === cell && toggle && cell.A && cell.D) dir = dir === 'A' ? 'D' : 'A';
      else if (!entryOf(cell, dir)) dir = dir === 'A' ? 'D' : 'A';
      cur = cell;
      paint();
    }
    function selectEntry(e) {
      dir = e.dir;
      var first = e.cells.filter(function (c) { return !c.val; })[0] || e.cells[0];
      cur = first;
      paint();
    }
    function focusInput() { if (inputEl && !done) { try { inputEl.focus({ preventScroll: true }); } catch (e) { inputEl.focus(); } } }

    function step(d) {  // move inside the active entry
      var ent = activeEntry(); if (!ent) return;
      var i = ent.cells.indexOf(cur) + d;
      if (i >= 0 && i < ent.cells.length) { cur = ent.cells[i]; paint(); }
    }
    function arrow(dr, dc) {
      var r = cur.r, c = cur.c;
      for (var n = 0; n < Math.max(ROWS, COLS); n++) {
        r += dr; c += dc;
        if (r < 0 || c < 0 || r >= ROWS || c >= COLS) return;
        var cl = cellMap[r + ',' + c];
        if (cl) {
          var wantDir = dr !== 0 ? 'D' : 'A';
          if (entryOf(cl, wantDir)) dir = wantDir;
          cur = cl; paint(); return;
        }
      }
    }
    function cycle(d) {
      var ent = activeEntry();
      var i = ent ? ENTRIES.indexOf(ent) : 0;
      selectEntry(ENTRIES[(i + d + ENTRIES.length) % ENTRIES.length]);
      focusInput();
    }

    function setLetter(ch) {
      if (!cur || done) return;
      cur.val = ch;
      cur.ch.textContent = ch;
      cur.el.classList.toggle('is-filled', !!ch);
      cur.el.classList.remove('is-wrong');
      if (statusEl) { statusEl.textContent = ''; statusEl.className = 'cw-status'; }
    }
    function type(ch) {
      setLetter(ch);
      var ent = activeEntry();
      var i = ent.cells.indexOf(cur);
      if (i < ent.cells.length - 1) { cur = ent.cells[i + 1]; paint(); }
      else paint();
      check();
    }
    function back() {
      if (cur.val) { setLetter(''); paint(); return; }
      step(-1); setLetter(''); paint();
    }

    function allCells() { return Object.keys(cellMap).map(function (k) { return cellMap[k]; }); }
    function check() {
      var cells = allCells();
      if (cells.some(function (c) { return !c.val; })) return;
      var wrong = cells.filter(function (c) { return c.val !== c.ans; });
      if (!wrong.length) { win(); return; }
      wrong.forEach(function (c) { c.el.classList.add('is-wrong'); });
      gridEl.classList.remove('shake'); void gridEl.offsetWidth; gridEl.classList.add('shake');
      if (statusEl) { statusEl.textContent = wrong.length + (wrong.length === 1 ? ' letter is' : ' letters are') + ' off.'; statusEl.className = 'cw-status err'; }
    }

    function win() {
      done = true;
      $('#cw').classList.add('is-solved');
      if (statusEl) { statusEl.textContent = 'Solved. Opening the doors.'; statusEl.className = 'cw-status ok'; }
      if (inputEl) inputEl.blur();
      setTimeout(function () {
        var wipe = $('#pw-wipe'); if (wipe) wipe.classList.add('active');
        setTimeout(function () {
          var pw = $('#password');
          var form = pw ? pw.closest('form') : null;
          if (pw) pw.value = PASSWORD;
          if (form) form.submit();
        }, 900);
      }, 900);
    }

    gridEl.addEventListener('click', function (e) {
      var t = e.target.closest('.cw-cell'); if (!t || t.classList.contains('cw-block')) return;
      selectCell(cellMap[t.dataset.r + ',' + t.dataset.c], true);
      focusInput();
    });
    $('#cw-prev').addEventListener('click', function () { cycle(-1); });
    $('#cw-next').addEventListener('click', function () { cycle(1); });

    inputEl.addEventListener('input', function () {
      var v = (inputEl.value || '').replace(/[^a-zA-Z]/g, '');
      inputEl.value = '';
      if (v) type(v.slice(-1).toUpperCase());
    });
    document.addEventListener('keydown', function (e) {
      if (done || !cur) return;
      var tag = (e.target && e.target.tagName) || '';
      if (tag === 'INPUT' && e.target !== inputEl) return;
      if (e.metaKey || e.ctrlKey || e.altKey) return;
      var k = e.key;
      if (k === 'Backspace') { e.preventDefault(); back(); }
      else if (k === 'ArrowLeft') { e.preventDefault(); arrow(0, -1); }
      else if (k === 'ArrowRight') { e.preventDefault(); arrow(0, 1); }
      else if (k === 'ArrowUp') { e.preventDefault(); arrow(-1, 0); }
      else if (k === 'ArrowDown') { e.preventDefault(); arrow(1, 0); }
      else if (k === 'Tab') { e.preventDefault(); cycle(e.shiftKey ? -1 : 1); }
      else if (k === ' ' || k === 'Enter') { if (tag !== 'BUTTON') { e.preventDefault(); selectCell(cur, true); } }
      else if (k.length === 1 && /[a-zA-Z]/.test(k) && e.target !== inputEl) { e.preventDefault(); type(k.toUpperCase()); }
    });

    /* start on 5 Across (the key word) */
    selectEntry(ENTRIES.filter(function (e) { return e.word === PASSWORD; })[0] || ENTRIES[0]);
    if (window.AK_SIGNUP && window.AK_SIGNUP.pwError && statusEl) {
      statusEl.textContent = 'Solved, but the store password is not ' + PASSWORD + '. Owner: fix it in Preferences.';
      statusEl.className = 'cw-status err';
    }
  }

  /* ---------- owner password field (tiny, for the store owner) ---------- */
  var ownerBtn = $('#px-owner'), ownerForm = $('#px-ownerform'), ownerIn = $('#px-ownerinput');
  if (ownerBtn && ownerForm) {
    ownerBtn.addEventListener('click', function () {
      var open = ownerForm.hidden;
      ownerForm.hidden = !open;
      ownerBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && ownerIn) ownerIn.focus({ preventScroll: true });
    });
    ownerForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var pw = $('#password'), form = pw ? pw.closest('form') : null;
      if (pw && form && ownerIn.value) { pw.value = ownerIn.value; form.submit(); }
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeSheet(); }
  });
})();
